function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Extract validation value from validations array by type
 * @param validations - Array of validation objects
 * @param validationType - Type of validation to extract (e.g., "max_length")
 * @returns Parsed validation value as number, or undefined if not found
 */
export var getValidationValue = function getValidationValue(validations, validationType) {
  var validation = validations === null || validations === void 0 ? void 0 : validations.find(function (v) {
    return v.type === validationType;
  });
  if (!validation) return undefined;
  return typeof validation.value === "number" ? validation.value : parseInt(validation.value, 10);
};
export var isDatePattern = function isDatePattern(pattern) {
  if (!pattern) return false;
  // and may have colons for time: mm/dd/yyyy or mm/dd/yyyy hh:mm:ss
  return pattern.includes("/") || pattern.includes(":") && pattern.includes("\\d{2}");
};
export var isNumericPattern = function isNumericPattern(pattern) {
  if (!pattern) return false;

  // Exclude date patterns
  if (isDatePattern(pattern)) return false;

  // Patterns that indicate numeric fields
  return pattern.includes("\\d") || /^\^?[\d\\.]+/.test(pattern);
};
export var allowsDecimals = function allowsDecimals(pattern) {
  if (!pattern) return false;
  return pattern.includes("\\.");
};
export var isValidPattern = function isValidPattern(value, pattern) {
  if (!value || !pattern) return false;
  var regex = new RegExp(pattern);
  return regex.test(value);
};
export var extractSeparators = function extractSeparators(pattern) {
  if (!pattern) return [];

  // Remove regex special characters to get only literal separators
  var cleaned = pattern;
  // Remove anchors
  cleaned = cleaned.replace(/[\^\$]/g, "");
  // Remove quantifiers like {3}, {2,4}, +, *, ?
  cleaned = cleaned.replace(/\{[^\}]+\}/g, "");
  cleaned = cleaned.replace(/[+*?]/g, "");
  // Remove grouping parentheses
  cleaned = cleaned.replace(/[\(\)]/g, "");
  // Remove alternation operator (pipe)
  cleaned = cleaned.replace(/\|/g, "");
  // Remove character classes like [A-Za-z0-9]
  cleaned = cleaned.replace(/\[[^\]]+\]/g, "");
  // Remove escape sequences like \d, \w, \s
  cleaned = cleaned.replace(/\\[a-zA-Z]/g, "");

  // Find remaining non-backslash characters (these are literal separators)
  var separators = [];
  for (var i = 0; i < cleaned.length; i++) {
    var _char = cleaned[i];
    // Skip backslashes themselves
    if (_char === "\\") continue;
    // Skip digits (0-9) - they're not separators
    if (/\d/.test(_char)) continue;

    // Any remaining character is a literal separator
    if (!separators.includes(_char)) {
      separators.push(_char);
    }
  }
  return separators;
};

/**
 * Check if pattern contains formatted separators (like hyphens, slashes, etc.)
 */
export var isFormattedPattern = function isFormattedPattern(pattern) {
  if (!pattern) return false;
  var separators = extractSeparators(pattern);
  return separators.length > 0;
};
export var hasOptionalSeparators = function hasOptionalSeparators(pattern) {
  if (!pattern) return false;
  var separators = extractSeparators(pattern);
  if (separators.length === 0) return false;

  // Check if any separator is followed by ?
  var _iterator = _createForOfIteratorHelper(separators),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var sep = _step.value;
      // Escape special regex characters in the separator
      var escapedSep = sep.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      // Check if this separator is followed by ?
      var optionalPattern = new RegExp("".concat(escapedSep, "\\?"));
      if (optionalPattern.test(pattern)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
export var countSeparatorInstances = function countSeparatorInstances(pattern) {
  if (!pattern) return 0;
  var separators = extractSeparators(pattern);
  if (separators.length === 0) return 0;

  // Remove escape sequences and character classes to count literal separators
  var cleaned = pattern;
  // Remove character classes like [A-Za-z0-9]
  cleaned = cleaned.replace(/\[[^\]]+\]/g, "");
  // Remove escape sequences like \d, \w
  cleaned = cleaned.replace(/\\[a-zA-Z]/g, "");
  // Remove quantifiers like {4}, {2,4}
  cleaned = cleaned.replace(/\{[^\}]+\}/g, "");
  // Remove anchors
  cleaned = cleaned.replace(/[\^\$]/g, "");

  // Remove optional separators (separator followed by ?)
  var _iterator2 = _createForOfIteratorHelper(separators),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var sep = _step2.value;
      var escapedSep = sep.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      cleaned = cleaned.replace(new RegExp("".concat(escapedSep, "\\?"), "g"), "");
    }

    // Count occurrences of each REQUIRED separator (those not followed by ?)
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var count = 0;
  var _iterator3 = _createForOfIteratorHelper(separators),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _sep = _step3.value;
      // Count how many times this separator appears (not followed by ?)
      var matches = cleaned.match(new RegExp(_sep.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"));
      count += matches ? matches.length : 0;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return count;
};
export var getAdjustedMaxLength = function getAdjustedMaxLength(maxLength, pattern) {
  if (!maxLength) return undefined;
  var separatorCount = countSeparatorInstances(pattern);
  return maxLength + separatorCount;
};
export var hasInvalidNumericCharacters = function hasInvalidNumericCharacters(value, allowDecimals, pattern) {
  if (!value) return false;

  // Check if pattern has separators (like SSN: 123-45-6789)
  var separators = extractSeparators(pattern);

  // Filter out decimal point from separators if allowDecimals is true
  // Decimal point should be handled by decimal-specific validation, not as a separator
  var nonDecimalSeparators = allowDecimals ? separators.filter(function (s) {
    return s !== ".";
  }) : separators;
  if (nonDecimalSeparators.length > 0) {
    // For formatted patterns, allow digits and the specific separators
    var escapedSeparators = nonDecimalSeparators.map(function (s) {
      return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }).join("");
    var regex = new RegExp("^[\\d".concat(escapedSeparators, "]*$"));
    return !regex.test(value);
  } else if (allowDecimals) {
    // Allow digits and single decimal point
    return !/^\d*\.?\d*$/.test(value);
  } else {
    // Only allow digits
    return !/^\d*$/.test(value);
  }
};
export var hasInvalidTextCharacters = function hasInvalidTextCharacters(value, pattern) {
  if (!value || !pattern) return false;

  // Check if pattern has separators (like hyphens in formatted IDs)
  var separators = extractSeparators(pattern);

  // For numeric patterns (like SSN: ^\d{3}-\d{2}-\d{4}$)
  if (pattern.includes("\\d") && !isDatePattern(pattern)) {
    // Check if it allows decimals
    var allowDecimals = pattern.includes("\\.");

    // Filter out decimal point from separators if allowDecimals is true
    var nonDecimalSeparators = allowDecimals ? separators.filter(function (s) {
      return s !== ".";
    }) : separators;
    if (nonDecimalSeparators.length > 0) {
      // For formatted numeric patterns, allow digits and the specific separators
      var escapedSeparators = nonDecimalSeparators.map(function (s) {
        return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }).join("");
      var regex = new RegExp("^[\\d".concat(escapedSeparators, "]*$"));
      return !regex.test(value);
    } else if (allowDecimals) {
      // Allow digits and single decimal point
      return !/^\d*\.?\d*$/.test(value);
    } else {
      // Only allow digits
      return !/^\d*$/.test(value);
    }
  }

  // For alphanumeric patterns
  if (pattern.includes("[A-Za-z0-9]") || pattern.includes("\\w")) {
    if (separators.length > 0) {
      // Allow alphanumeric and the specific separators
      var _escapedSeparators = separators.map(function (s) {
        return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }).join("");
      var _regex = new RegExp("^[A-Za-z0-9".concat(_escapedSeparators, "]*$"));
      return !_regex.test(value);
    }
    return !/^[A-Za-z0-9]*$/.test(value);
  }

  // For alphabet-only patterns
  if (pattern.includes("[A-Za-z]")) {
    if (separators.length > 0) {
      // Allow alphabets and the specific separators
      var _escapedSeparators2 = separators.map(function (s) {
        return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }).join("");
      var _regex2 = new RegExp("^[A-Za-z".concat(_escapedSeparators2, "]*$"));
      return !_regex2.test(value);
    }
    return !/^[A-Za-z]*$/.test(value);
  }
  return false;
};
export var isOutOfRange = function isOutOfRange(value, minValue, maxValue) {
  if (!value || !value.length) return false;
  if (minValue == null && maxValue == null) return false;
  var numValue = parseFloat(value);
  if (isNaN(numValue)) return false;
  if (minValue != null && numValue < minValue) {
    return true;
  }
  if (maxValue != null && numValue > maxValue) {
    return true;
  }
  return false;
};
export var getInvalidCharacterMessage = function getInvalidCharacterMessage(allowDecimals, pattern, formatHint) {
  var separators = extractSeparators(pattern);
  if (separators.length > 0 && formatHint) {
    return "Format: ".concat(formatHint);
  } else if (separators.length > 0) {
    return "Only numbers and \"".concat(separators.join('", "'), "\" allowed");
  } else if (allowDecimals) {
    return "Only numbers and decimal point allowed";
  } else {
    return "Only numbers allowed";
  }
};
export var getRangeErrorMessage = function getRangeErrorMessage(minValue, maxValue) {
  if (minValue != null && maxValue != null) {
    return "Value must be between ".concat(minValue, " and ").concat(maxValue);
  } else if (minValue != null) {
    return "Value must be at least ".concat(minValue);
  } else if (maxValue != null) {
    return "Value must be at most ".concat(maxValue);
  }
  return "Value out of range";
};
export var shouldUseNumericValidation = function shouldUseNumericValidation(dataType, pattern) {
  // Explicit numeric types
  var numericTypes = ["number", "integer", "float", "decimal"];
  if (dataType && numericTypes.includes(dataType.toLowerCase())) {
    return true;
  }

  // Check pattern for numeric validation
  return isNumericPattern(pattern);
};

/**
 * Get border and background classes for form inputs based on validation state
 * Priority: Error > Required+Empty > Default
 */
export var getInputBorderAndBackgroundClasses = function getInputBorderAndBackgroundClasses(hasError, isRequired, isEmpty) {
  if (isRequired && isEmpty) {
    return "!border-[#FBDF9B] bg-[#F9EBCA] dark:!border-[#805500] dark:bg-[#422A10]";
  } else if (hasError) {
    return "!border-[#F9BCC2] bg-[#FBDEE1] dark:!border-[#711F2C] dark:bg-[#451B28]";
  } else return "!border-[#BBBFC2] bg-[#F3F4F4] dark:!border-[#646B72] dark:bg-[#0C1723]";
};